"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importStar(require("react"));
const formik_1 = require("formik");
const index_1 = require("./../index");
const styled_components_1 = __importDefault(require("styled-components"));
const Label_1 = require("./Label");
const _1 = require(".");
const Error = styled_components_1.default.div `
  color: ${(props) => props.theme.error};
  border-radius: ${(props) => props.theme.radius};
  grid-column-start: 2;
`;
const Select = (props) => {
    var _a;
    const [field, meta] = (0, formik_1.useField)(props.name);
    const dropdownRef = (0, react_1.useRef)(null);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        props.hideLabel ? null : react_1.default.createElement(Label_1.MultiLineLabel, { ...props }),
        react_1.default.createElement(index_1.Flex, { col: true, noWrap: true },
            react_1.default.createElement("div", { ref: dropdownRef, style: {
                    display: "inline-block",
                    position: "relative",
                    maxWidth: props.maxWidth,
                } },
                react_1.default.createElement(Dropdown, { disabled: props.disabled, invalid: meta.touched && meta.error !== undefined, id: field.name, ...field, "data-testid": (_a = props.testId) !== null && _a !== void 0 ? _a : "", onChange: (e) => {
                        props.handleChange
                            ? props.handleChange(e.target.value)
                            : field.onChange(e);
                    }, style: { cursor: props.disabled ? "default" : "pointer" } },
                    props.defaultSelectedText && (react_1.default.createElement("option", { key: props.defaultSelectedText, value: props.defaultSelectedText, disabled: true, style: { fontStyle: "italic", opacity: 0.5 } }, props.defaultSelectedText)),
                    props.options.map((o) => o.label === props.defaultSelectedText ? null : (react_1.default.createElement("option", { key: o.value, value: o.value, disabled: !!o.disabled }, o.label)))),
                react_1.default.createElement(index_1.Flex, { style: {
                        position: "absolute",
                        top: "40%",
                        right: "-3px",
                        transform: "translate(-50%, -50%)",
                        pointerEvents: "none",
                        opacity: props.disabled ? 0.5 : 1,
                    } },
                    react_1.default.createElement(index_1.ArrowDown, null)))),
        meta.error && meta.touched && react_1.default.createElement(Error, null, meta.error)));
};
exports.Select = Select;
const Dropdown = styled_components_1.default.select `
  min-height: 30px;
  flex: 1;
  width: 100%;
  padding-left: 8px;
  padding-right: 20px;
  padding-bottom: 2px;
  color: ${({ theme }) => theme.fg};
  background: ${({ theme }) => theme.button.bg.normal};
  background-image: ${({ theme }) => theme.comboBox.background.normal};
  box-shadow:
    ${({ theme }) => theme.boxShadows.highlight},
    ${({ theme }) => theme.boxShadows.low};

  border-radius: ${({ theme }) => theme.radius};
  cursor: pointer;
  white-space: nowrap;
  text-overflow: ellipsis;
  &:not(:disabled):hover {
    background-image: ${({ theme }) => theme.comboBox.background.hover};
  }
  &:not(:disabled):active {
    background: ${({ theme }) => theme.comboBox.background.active};
  }
  ${(props) => (0, _1.getInvalidStyle)(props.invalid, props.theme.error)}

  &:disabled {
    opacity: 0.5;
  }

  option {
    background: ${({ theme }) => theme.comboBox.options.background};
    white-space: pre;
    &:disabled {
      color: ${({ theme }) => theme.headerFg};
    }
  }

  /* Remove the default select arrow */
  appearance: none;
`;
//# sourceMappingURL=Select.js.map